/** Tipos de Endereços */
export interface PessoaEnderecoTipo {
    id: number;
    nome: string;
}

export const enderecoTipoPrincipal: PessoaEnderecoTipo = {id: 1, nome: 'Principal'};
export const enderecoTipoCobranca: PessoaEnderecoTipo = {id: 2, nome: 'Cobranca'};
export const enderecoTipoEntrega: PessoaEnderecoTipo = {id: 3, nome: 'Entrega'};

export const enderecoTipos: PessoaEnderecoTipo[] = [
    enderecoTipoPrincipal,
    enderecoTipoCobranca,
    enderecoTipoEntrega
];

/** Verifica se o tipo do endereço informado é Principal */
export function isEnderecoTipoPrincipal(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === enderecoTipoPrincipal.id;
}

/** Verifica se o tipo do endereço informado é Cobranca */
export function isEnderecoTipoCobranca(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === enderecoTipoCobranca.id;
}

/** Verifica se o tipo do endereço informado é Entrega */
export function isEnderecoTipoEntrega(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === enderecoTipoEntrega.id;
}
